import { useTranslations } from 'next-intl';
import { sourcingDetails } from 'services/cart/types';
import { v4 as uuidv4 } from 'uuid';
import { CatButton } from 'components/blocks-components';
import { AvailabilityLine } from '../availability-line';
import { AvailabilityQuantity } from '../availability-quantity';
import {
  CONTACT_DEALER_SEQUENCES,
  CD_AVAILAVILITY_MSG_SEQUENCE
} from '../constants';
import { SourcingDetails } from 'services/dealerPriceAvailability/types';
import { ContactDealerPopover } from '../contact-dealer-popover/contact-dealer-popover';
import { LocationAddress } from 'services/location/types';
import styles from '../product-availability.module.scss';

export interface ProductAvailabilityBySourceProps {
  sourcingDetails: sourcingDetails[] | SourcingDetails[];
  isCompact?: boolean;
  shouldWrap?: boolean;
  storeAddress?: LocationAddress;
  isPrint?: boolean;
}

export function ProductAvailabilityBySource({
  sourcingDetails,
  isCompact = false,
  shouldWrap = false,
  storeAddress,
  isPrint = false
}: Readonly<ProductAvailabilityBySourceProps>) {
  const t = useTranslations();

  return (
    <div>
      {sourcingDetails?.map(
        ({ availStoreList, availabilityMessage, sequence }) =>
          availStoreList?.map(
            ({ storeName, quantityAvailable, leadTimeDateRange }) => {
              const isInStock =
                storeName?.toLowerCase() === t('MO_SHIP_IN_STOCK')?.toLowerCase(); // Extracting from message because there is no field for inStock
              const isContactDealer =
                CONTACT_DEALER_SEQUENCES.includes(sequence);

              return (
                <AvailabilityLine
                  key={uuidv4()}
                  isCompact={isCompact}
                  shouldWrap={shouldWrap}
                  isPrint={isPrint}
                >
                  <AvailabilityQuantity
                    isInStock={isInStock}
                  >{`${quantityAvailable} `}</AvailabilityQuantity>
                  {isContactDealer || isInStock ? (
                    <>
                      {isContactDealer && (
                        <ContactDealerPopover storeAddress={storeAddress}>
                          <CatButton
                            variant="inline"
                            className={
                              styles['product-availability__no-print-hyperlink']
                            }
                            {...(isCompact && { size: 'sm' })}
                          >
                            {sequence === CD_AVAILAVILITY_MSG_SEQUENCE
                              ? availabilityMessage
                              : storeName || t('CONTACT_YOUR_DEALER')}
                          </CatButton>
                        </ContactDealerPopover>
                      )}
                      {isInStock && t('MO_SHIP_IN_STOCK')}
                    </>
                  ) : (
                    <>
                      {storeName}
                      {leadTimeDateRange && ` (${leadTimeDateRange})`}
                    </>
                  )}
                </AvailabilityLine>
              );
            }
          )
      )}
    </div>
  );
}
